// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2O62t","col":"styles_col__1BMMt"};